// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialMedia_container__RERh7","title":"SocialMedia_title__zMh2F","linksContainer":"SocialMedia_linksContainer__XPAPb","icon":"SocialMedia_icon__QNi8B"};